import React from 'react';
import ReactPaginate from 'react-paginate';
import { useTranslation } from 'react-i18next';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import usePagination, { PaginationProps } from '@lib/hooks/usePagination';
import isMobile from '@lib/utils/isMobile';
import styles from './Pagination.module.scss';

function Pagination(props: PaginationProps) {
  const { page, pageCount, onPageChange } = usePagination(props);
  const { phone } = isMobile();
  const { t } = useTranslation();
  return (
    <ReactPaginate
      pageCount={+pageCount}
      onPageChange={({ selected: newPage }) => onPageChange(newPage + 1)}
      marginPagesDisplayed={phone ? 1 : 2}
      pageRangeDisplayed={phone ? 1 : 2}
      forcePage={Number(page) - 1}
      disableInitialCallback
      previousLabel={
        <span
          className={styles.buttonRow}
          data-test-id="pagination__prev-button"
        >
          <MaterialIcon icon="arrow_back" size="md-20" symbolsOutlined />
          {!phone && t('prev')}
        </span>
      }
      nextLabel={
        <span
          className={styles.buttonRow}
          data-test-id="pagination__next-button"
        >
          {!phone && t('next')}
          <MaterialIcon icon="arrow_forward" size="md-20" symbolsOutlined />
        </span>
      }
      containerClassName={styles.root}
    />
  );
}

export default Pagination;
